/**
 * Stripe Payment Link configuration
 * 
 * This is the ONLY way to start a trial/payment flow.
 * All "Start Free Trial" buttons should use redirectToStripeCheckout().
 * 
 * NO fetch, NO Supabase Function, NO Stripe SDK, NO backend, NO CORS.
 * Just a simple browser redirect.
 */

export const STRIPE_PAYMENT_LINK = "https://buy.stripe.com/eVq8wHgUKej6aqV1VqcEw00";

/**
 * Redirects user to Stripe Payment Link for checkout
 * 
 * Simple browser redirect - no API calls, no backend, no CORS issues.
 * If redirect fails (extremely rare), shows a fallback alert.
 */
export function redirectToStripeCheckout() {
  try {
    window.location.assign(STRIPE_PAYMENT_LINK);
  } catch (err) {
    alert(
      "If the redirect did not start automatically, open this link:\n\n" +
      STRIPE_PAYMENT_LINK
    );
  }
}

